import React, { useState } from 'react'
import { Tabs, Tab, Icon } from '@blueprintjs/core'
import { SegmentationExplorerWeights } from './SegmentationExplorerWeights'
import { SegmentationScoresSummary } from './SegmentationScoresSummary'
import { useSegmentationPriorities } from '../../contexts/SegmentationPrioritiesProvider'

/**
 * WeightsGroupTabs component renders a tab view that toggles between the weights configuration
 * and the segmentation scores summary.
 *
 * @param {Object} props - Component props
 * @param {Array} props.selectedSegmentations - Currently selected segmentations for scoring
 * @param {Function} props.onSelectedSegmentationsChange - Callback when segmentations selection changes
 * @returns {JSX.Element} The rendered tab component.
 */
export function WeightsGroupTabs({
  selectedSegmentations = [],
  onSelectedSegmentationsChange,
}) {
  const [selectedTab, setSelectedTab] = useState('weights')
  const { isFetchingScores } = useSegmentationPriorities()

  return (
    <Tabs
      id="weightTabs"
      selectedTabId={selectedTab}
      onChange={tabId => setSelectedTab(tabId)}
    >
      <Tab
        id="weights"
        title={
          <>
            <Icon icon="lab-test" />
            <span style={{ marginLeft: '8px' }}>Weights</span>
          </>
        }
        panel={
          <div style={{ height: '100%', overflowY: 'auto' }}>
            <SegmentationExplorerWeights />
          </div>
        }
        disabled={isFetchingScores}
      />
      <Tab
        id="summary"
        title={
          <>
            <Icon icon="info-sign" />
            <span style={{ marginLeft: '8px' }}>Summary</span>
          </>
        }
        panel={
          <SegmentationScoresSummary
            selectedSegmentations={selectedSegmentations}
            onSelectedSegmentationsChange={onSelectedSegmentationsChange}
          />
        }
      />
    </Tabs>
  )
}
